import { connect } from 'react-redux';

import { getOfficesShortList } from '../../Offices/officesActions';
import { getOrganizationMembersList } from '../../Projects/projectsActions';
import { editSubTask, getTasksList, updateTaskApproval, reassignAssignee } from '../tasksActions';
// Component
import TaskApproval from './TaskApproval';

// Store props to map with current state
const mapStateToProps = state => ({
  memberShortListIsLoading: state.project.memberShortListIsLoading,
  selectedOrganization: state.organization.selectedOrganization,
  reassignAssigneeLoading: state.task.reassignAssigneeLoading,
  orgMembersList: state.project.orgMembersList,
  officesShortList: state.office.officesShortList,
  duplicateIsLoading: state.task.duplicateIsLoading,
  deleteIsLoading: state.task.deleteIsLoading,
  deletedCallback: state.task.deletedCallback,
  tasksList: state.task.tasksList,
  createdTaskInfo: state.task.createdTaskInfo,
  duplicateTaskInfo: state.task.duplicateTaskInfo,
  isLoading: state.task.isLoading,
  loadingTaskAssigneeId: state.project.loadingTaskAssigneeId,
  // pagination
  totalTasksCount: state.task.tasksListCount,
  pageSize: state.task.taskListPageSize,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getOrganizationMembersList: params =>
    dispatch(getOrganizationMembersList(params)),
  getTasksList: params => dispatch(getTasksList(params)),
  getOfficesShortList: params => dispatch(getOfficesShortList(params)),
  updateTaskApproval: params => dispatch(updateTaskApproval(params)),
  editSubTask: params => dispatch(editSubTask(params)),
  reassignAssignee: params => dispatch(reassignAssignee(params)),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(TaskApproval);
